import { signOut } from 'aws-amplify/auth';

export const userStore = {
  getAuthToken: (): string | null => {
    return sessionStorage.getItem('access_token');
  },

  setAuthToken: (token: string): void => {
    sessionStorage.setItem('access_token', token);
  },

  getUser: (): any => {
    const value = localStorage.getItem('user');
    return value ? JSON.parse(value) : null;
  },

  setUser: (user: any): void => {
    localStorage.setItem('user', JSON.stringify(user));
  },

  clear: (): void => {
    localStorage.removeItem('user');
    localStorage.removeItem('profile');
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');
    sessionStorage.removeItem('id_token');
  },
};

let isLoggingOut = false;

export const handleLogout = () => {
  if (isLoggingOut) return;
  isLoggingOut = true;

  userStore.clear();
  sessionStorage.clear();

  const keysToRemove = ['user', 'profile', 'auth_session', 'login_time'];
  keysToRemove.forEach(key => localStorage.removeItem(key));

  signOut().catch(() => undefined);

  const returnUrl = window.location.pathname;
  localStorage.setItem('returnUrl', returnUrl);

  window.location.href = '/';
};

export const isLogoutInProgress = (): boolean => isLoggingOut;

export const decodeJwt = (token: string): Record<string, any> | null => {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    return JSON.parse(atob(parts[1]));
  } catch {
    return null;
  }
};

export const getJwtSub = (): string => {
  const token = sessionStorage.getItem('access_token') || sessionStorage.getItem('id_token');
  if (!token) return '';
  const claims = decodeJwt(token);
  return typeof claims?.sub === 'string' ? claims.sub : '';
};
